import {
  Baby,
  Footprints,
  Gem,
  Layers,
  ShoppingBag,
  Shirt,
  Sparkles,
  Tag,
  Watch,
  type LucideIcon,
} from "lucide-react";
import { categoryIconKey, type CategoryIconKey } from "@/lib/homeCatalog";

/**
 * Pemetaan kunci ikon kategori → ikon lucide, DI-SHARE oleh baris tile kategori
 * beranda (`CategoryRow`) dan landing halaman Kategori (`KategoriClient`) supaya
 * ikonnya konsisten. Ini jalur FALLBACK terakhir `CategoryThumb`: ikon
 * diturunkan dari kata kunci nama lewat `categoryIconKey`, dipakai saat
 * kategori BELUM punya ikon unggahan (`product_categories.icon_url`, mig 0951)
 * MAUPUN produk berfoto.
 */
export const CATEGORY_ICONS: Record<CategoryIconKey, LucideIcon> = {
  bag: ShoppingBag,
  baby: Baby,
  dress: Shirt,
  shirt: Shirt,
  shoe: Footprints,
  hijab: Sparkles,
  accessory: Gem,
  watch: Watch,
  outer: Layers,
  generic: Tag,
};

/** Ikon lucide untuk sebuah nama kategori (teks bebas dari admin). */
export function categoryIcon(name: string): LucideIcon {
  return CATEGORY_ICONS[categoryIconKey(name)];
}
